import { pluralize } from "@shared/svelte/Modules/pluralize";

export const ContainerDescription = function (product, hideCaseSize = false) {
  const res = [];
  if (product.container_size) {
    let size = String(product.container_size);
    if (product.container_units) {
      size += ` ${product.container_units}`;
      if (product.container_type) {
        if (product.container_type === "bottle" && product.material) {
          size += ` ${product.material} ${product.container_type}`;
        } else {
          size += ` ${product.container_type}`;
        }
      }
    }
    res.push(size);
  }

  if (product.container_carton_size && product.container_carton_size > 1) {
    res.push(`${String(product.container_carton_size)} pack`);
  }
  if (!hideCaseSize && product.container_type !== "keg" && product.container_case_size) {
    res.push(
      `${String(product.container_case_size)} ${pluralize(
        product.container_type,
        product.container_case_size,
      )}/case`,
    );
  }
  return res.join(" - ");
};
